/**
 * @generated SignedSource<<f885247a7ec3fca4d37e7e1a12b679a1>>
 * @relayHash c5dcbe8f669c934018c8f20fbbc93b8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 16dfdce3bf40db2e81ecfeeb0047aa00e9b4f3bdcdaca17ad0b1ebbeef7ded36

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_QUEUE_PAGE" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type JiraJqlScopeInput = {
  board?: JiraJqlBoardInput | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type HydrationRefetchQuery$variables = {
  accountId: string;
  cloudId: string;
  filterAri: string;
  includeJira: boolean;
  includeUser: boolean;
  isFilter: boolean;
  isPlanReleaseFeatureToggleEnabled: boolean;
  jql?: string | null | undefined;
  scope?: JiraJqlScopeInput | null | undefined;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type HydrationRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_jqlBuilder_JQLBuilderUI_hydrationQueryData">;
};
export type HydrationRefetchQuery = {
  response: HydrationRefetchQuery$data;
  variables: HydrationRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeJira"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isFilter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPlanReleaseFeatureToggleEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jql"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scope"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "viewContext"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  (v2/*: any*/)
],
v4 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v5 = {
  "kind": "Variable",
  "name": "viewContext",
  "variableName": "viewContext"
},
v6 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = [
  {
    "concreteType": "JiraStatusCategory",
    "kind": "LinkedField",
    "name": "statusCategory",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "colorName"
      },
      (v2/*: any*/)
    ]
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v11 = [
  (v1/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "jql"
      },
      {
        "kind": "LinkedField",
        "name": "fields",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "concreteType": "JiraJqlField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "concreteType": "JiraJqlSearchTemplate",
                    "kind": "LinkedField",
                    "name": "searchTemplate",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldShowInContext"
                  },
                  {
                    "condition": "isPlanReleaseFeatureToggleEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          (v4/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "shouldExcludeInScope"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "operators"
                  },
                  {
                    "concreteType": "JiraFieldType",
                    "kind": "LinkedField",
                    "name": "fieldType",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "small"
                                      }
                                    ]
                                  },
                                  (v2/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlProjectFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v9/*: any*/),
                            "type": "JiraJqlStatusFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v9/*: any*/),
                            "type": "JiraJqlStatusCategoryFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "xsmall"
                                      }
                                    ]
                                  },
                                  (v2/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueTypeFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v3/*: any*/)
                              }
                            ],
                            "type": "JiraJqlUserFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                  },
                                  (v2/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlPriorityFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "text"
                                                  }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              },
                                              (v2/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v2/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlIssueFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "sprint",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "state"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "boardName"
                                  },
                                  (v2/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlSprintFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "concreteType": "JiraJqlCascadingOptionFieldValue",
                                "kind": "LinkedField",
                                "name": "parentOption",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v6/*: any*/),
                                  (v10/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlCascadingOptionFieldValue"
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlQueryHydratedValue"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "error",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraJqlQueryHydratedError"
                  }
                ]
              }
            ],
            "type": "JiraJqlQueryHydratedField"
          }
        ]
      }
    ],
    "type": "JiraJqlHydratedQuery"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "message"
      }
    ],
    "type": "QueryError"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HydrationRefetchQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HydrationRefetchQuery",
    "selections": [
      {
        "condition": "includeUser",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "accountId"
              }
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v3/*: any*/)
          }
        ]
      },
      {
        "condition": "includeJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                  }
                ],
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "condition": "isFilter",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "jql"
                          },
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "kind": "LinkedField",
                        "name": "hydrateJqlQuery",
                        "plural": false,
                        "selections": (v11/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "isFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "filterAri"
                          },
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "kind": "LinkedField",
                        "name": "hydrateJqlQueryForFilter",
                        "plural": false,
                        "selections": (v11/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "16dfdce3bf40db2e81ecfeeb0047aa00e9b4f3bdcdaca17ad0b1ebbeef7ded36",
    "metadata": {},
    "name": "HydrationRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7e21dbd6ea1814b23402a1d8df10c1a7";

export default node;
